/* 
  Simple version info service
*/

import { Plugin } from "plugin";

import * as v8 from "v8";
import {procfs} from "procfs";


class Service extends Plugin {
  constructor(...args) {
    super(...args);
  }
  async RM_getV8Version() {
    return v8.getVersion();
  }
  async RM_getLinuxVersion() {    
    return procfs.version();
  }
}

export default Service;